import { Breakpoint } from '@mui/material/styles';
import GlobalTheme from '../../../theme';

/**
 * @description A function that compares two breakpoints and returns -1, 0, or 1
 */
export default function compareBreakpoints(
  bpA: Breakpoint,
  bpB: Breakpoint
): -1 | 0 | 1 {
  const breakpoints: Breakpoint[] = GlobalTheme.breakpoints.keys;
  const [indexA, indexB] = [breakpoints.indexOf(bpA), breakpoints.indexOf(bpB)];
  if (indexA < indexB) return -1;
  if (indexA > indexB) return 1;
  return 0;
}
